export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["المتلقي"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["الصانع"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["معرف المتلقي"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["معرف الصانع"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["أنت تدفع"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["أنت تحصل"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["وقت الانتظار"])},
  "8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["الاسم"])},
  "9": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["حساب بنكي/محفظة"])},
  "10": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["الوصف"])},
  "11": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["لا يوجد اسم بنك"])},
  "12": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["لا يوجد حساب بنكي"])},
  "13": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["لم يتم توفير اسم"])},
  "14": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["لم يتم توفير حساب"])},
  "15": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["خارجي"])},
  "16": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["داخلي"])}
}